<template>
  <div ref="root" class="top-button__container">
    <div class="top-button" :class="{ active: isFixed }" @click="toTop">
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.333374 11L2.21337 12.88L9.66671 5.43998V21.6666H12.3334V5.43998L19.7734 12.8933L21.6667 11L11 0.333313L0.333374 11Z" fill="#707070"/>
      </svg>
    </div>
  </div>
</template>

<script setup>

const isFixed = ref(false)
const observer = ref(null)
const root = ref(null)

const observeIntersect = () => {
  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0,
  }
  const handleIntersect = (entries, observer) => {
    entries.forEach(entry => {
      isFixed.value = !entry.isIntersecting
    })
  }
  observer.value = new IntersectionObserver(handleIntersect, options)
  observer.value.observe(root.value)
}

const toTop = () => {
  window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
}

onMounted(() => {
  observeIntersect()
})

</script>

<style lang="scss" scoped>
.top-button__container {
  display: none;
  position: absolute;
  height: 8.9rem;
  @media screen and (min-width: $tablet-breakpoint) {
    display: block;
  }
}
.top-button {
  display: none;
  position: fixed;
  opacity: 0.8;
  background: $color-white;
  width: 5.8rem;
  height: 5.8rem;
  border-radius: 50%;
  right: 2.4rem;
  bottom: 2.4rem;
  box-shadow: 0 0.2rem 0.4rem rgba(0, 0, 0, 0.08);
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 99;
  // &::after {
  //   content: '';
  //   background: url('~assets/images/arrow-down-gray.svg');
  //   height: 2.133rem;
  //   width: 2.133rem;
  // }
  @media screen and (min-width: $tablet-breakpoint) {
    &.active {
      display: flex;
    }
  }
  @media screen and (min-width: $pc-breakpoint) {
    right: 4rem;
    bottom: 4rem;
  }
}
</style>
